export let plMessages={
  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"E-mail",
  "password":"Hasło",
  "remember":"Zapamiętaj mnie",
  "forget":"Nie pamiętasz hasła?",
  "sign in":"Zaloguj się",
  "login":"Login",
  "sign up now":"Zarejestruj się teraz",
  "apply":"Poproś o założenie konta",
  "contact us":"Skontaktuj się z nami",
  "Privacy Policy":"Zasady zachowania poufności informacji",
  "Terms of Use":"Warunki użytkowania",
  "copyright":"Copyright © 2021 Medtrum Technologies Inc. Wszelkie prawa zastrzeżone.",

  "chooseLang":"Wybierz kraj lub język",
  "asia":"Azja",
  "europe":"Europa",
  "middleEast":"Middle East",

  "applyHcp":"Poproś o założenie konta pracownika służby zdrowia",
  "sign up":"Zarejestruj się",
  "Patient":"Pacjent",
  "Caregiver":"Opiekun",
  "Email":"E-mail",
  "Mobile":"Telefon komórkowy",
  "Enter email":"Podaj adres e-mail",
  "Enter mobile":"Podaj numer telefonu komórkowego",
  "Verification":"Kod weryfikacyjny",
  "Invitation":"Invitation code",
  "full name":"Podaj imię i nazwisko",
  "Enter pass":"Podaj hasło",
  "org":"Organizacja",
  "Register":"Register",
  "send":"Wyślij",
  "createAccount":"Create Account",
  "agree":"Znam i akceptuję zasady zachowania poufności informacji oraz warunki świadczenia usług firmy Medtrum.",
  "privacy":"   ",
  "and" :" ",
  "use":" ",
  "errtip1-1":"Musisz podać działający adres e-mail, który będzie Twoją nazwą użytkownika nadaną przez firmę Medtrum.",
  "errtip1-2":"",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Błędny kod weryfikacyjny",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Błędna nazwa użytkownika",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Podaj organizację.",

  "errp1":"Hasło musi zawierać co najmniej 3 następujące rodzaje znaków:",
  "errp2":"małe litery, wielkie litery, cyfry i znaki specjalne.",
  "errp3":"Hasło musi zawierać od 6 do 20 znaków.",
  "errp4":"Hasło nie może być identyczne jak nazwa użytkownika.",
  "errp5":"Hasło zawierające 3 kolejne cyfry jest nieprawidłowe (np.: 123, 321).",
  "errp6":"Hasło zawierające 3 kolejne litery jest nieprawidłowe (np.: abc, cba).",
  "errp7":"Hasło nie może zawierać spacji.",


  "Find account":"Pobierz hasło.",
  "Enter username":"Podaj nazwę użytkownika.",
  "Next":"Dalej",
  "Cancel":"Anuluj",
  "Back":"Wstecz",
  "Enter veri":"Enter verification code",
  "Verify notice":"Poszukaj kodu weryfikacyjnego w wiadomości e-mail.",
  "Create new":"Utwórz nowe hasło",
  "Create new notice":"Utwórz nowe hasło. Hasło musi mieć co najmniej 6 znaków.",
  "New pass" :"Nowe hasło",
  "Completed":"Zakończono",
  "Created":"Utworzono nowe hasło.",
  "Login Now":"Zaloguj się",

  "Delete":"Usuń",
  "New Patient":"New Patient",
  "Add Patient":"Dodaj pacjenta",
  "Filter":"Filtr",
  "Name":"Imię i nazwisko",
  "Gender":"Płeć",
  "Age":"Wiek",
  "Type":"Typ",
  "Duration":"Czas trwania",
  "Connections":"Twórca konta",
  "UploadTime":"Czas przesyłania",
  "Year":"Rok",
  "Years":"Lata",
  "Month":"month",
  "Month2":"Miesiąc",
  "Months":"months",
  "Invite":"Zaproś",
  "Invited":"Zaproszono",
  "All":"Razem",
  "Female":"Kobieta",
  "Male":"Mężczyzna",
  "Not Set":"Not Set",
  "Type 1":"Typ 1",
  "Type 2":"Typ 2",
  "Gestational":"Ciążowy",
  "Prediabetes":"Stan przedcukrzycowy",
  "LADA":"Typ 1.5 LADA",
  "Apply":"Zastosuj",
  "disUn":"Nieokreślony typ cukrzycy",
  "ageUn":"Nieokreślony wiek",
  "genUn":"Nieokreślona płeć",
  "addP":"Dodaj pacjenta",
  "newP":"Nowy pacjent",
  "findP":"Znajdź pacjenta",

  "GDRNF":"Nie określono",
  "GDRF":"Kobieta",
  "GDRM":"Mężczyzna",
  "女":"Mężczyzna",

  "DBTNF":"Nie określono",
  "DBT1":"Typ 1",
  "DBT2":"Typ 2",
  "DBTLADA":"Typ 1.5 LADA",
  "DBTPRE":"Stan przedcukrzycowy",
  "DBTGEST":"Ciążowy",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"No selection",
  "unspecif":"Nie określono",
  "register":"Pacjent",
  "hcp":"Lekarz",

  "BG":"GK",
  "CARB":"Węglowodany",
  "INS":"Iniekcja",
  "EXR":"Ćwiczenia",
  "OTR":"Inne",
  "HBA1C":"HbA1c",
  "DOSE":"Dawka",
  "URINEK":"Ketony w moczu",
  "HEL":"HEL",
  "OTR1":"Inne",
  "Loading":"Wczytywanie",

  "home":"Strona główna",
  "pID":"ID pacjenta",
  "fullName":"Imię i nazwisko",
  "gender":"Płeć",
  "height":"Wzrost",
  "weight":"Masa",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Data urodzin",
  "disType":"Typ cukrzycy",
  "disDate":"Data zdiagnozowania",
  "Address":"Adres",
  "Postcode":"Kod pocztowy",
  "Inpatient":"Pacjent hospitalizowany",
  "Yes":"Tak",
  "No":"Nie",
  "Pno":"Nr pacjenta",
  "Bno":"Nr łóżka",
  "create":"Utwórz",
  "Telephone":"Telefon",

  "enterU":"Podaj nazwę użytkownika (e-mail)",
  "search":"Szukaj",
  "noU":"Wymagana jest nazwa użytkownika.",
  "searchR":"Wyniki wyszukiwania",
  "uername":"Nazwa użytkownika",
  "alias":"Alias:",
  "remove":"Usuń",
  "viewG":"Wyświetl wykresy",
  "sendR":"Wyślij prośbę",
  "rSent":"Prośba została wysłana.",
  "cancelR":"Anuluj prośbę",

  "VcodeTip1":"Nic nie dotarło? Poczekaj minutę i spróbuj ponownie.",
  "VcodeTip2":"",
  "VcodeTip3":"Wysłaliśmy kod weryfikacyjny na adres ",
  "Entercode":"Wpisz kod",
  "Getcode":"Uzyskaj kod",

  "messages":"Komunikaty",
  "profile":"Profil",
  "sign out":"Wyloguj się",
  "changeP":"Zmień hasło",
  "connection":"Połączenia",

  "myP":"Mój profil",
  "Portrait":"Zdjęcie profilowe",
  "Profession":"Zawód",
  "DPRONF":"Nie określono",
  "DPROENDOCRIN":"Endokrynolog",
  "DPRODIABTRA":"Edukator diabetologiczny",
  "DPRONURSE":"Pielęgniarka",
  "DPRODIATIT":"Dietetyk",
  "DPROOTR":"Inni pracownicy służby zdrowia",
  "Organization":"Organizacja",
  "Bio":"Bio",
  "save":"Zapisz",
  "oldPa":"Poprzednie hasło ",
  "newPa":"Nowe hasło",
  "RePa":"Powtórz hasło",
  "forgetY":"Nie pamiętasz hasła?",
  "applyM":"Zastosuj",
  "oldErr":"Błędne poprzednie hasło.",
  "EntTheSame":"Ponownie podaj nowe hasło.",
  "EnterOld":"Podaj poprzednie hasło.",

  "pList":"Lista pacjentów",
  "connections":"Połączenia",
  "settings":"Ustawienia",
  "monitor":"Monitor",
  "graphs":"Raporty",
  "events":"Zdarzenia",
  "records":"Rekordy",
  "qPrint":"Szybki wydruk",

  "sensorIn":"Informacje o czujniku",
  "timeOfLaRead":"Godzina ostatniego odczytu czujnika",
  "tranSn":"Numer seryjny nadajnika",
  "status":"Status",
  "sensorLife":"Pozostały czas przydatności czujnika",
  "lastSenorRead":"Ostatni odczyt czujnika",
  "TranBattery":"Bateria nadajnika",
  "sg":"SG",
  "alert":"Alert",
  "target":"Cel",
  "hypo":"Hipogl.",
  "sensorGlucose":"Poziom glukozy z czujnika",
  "calib":"Kalibracja",
  "newSen":"Nowy czujnik",
  "warm":"Rozgrzewanie",
  "InsulinPump":"Pompa insulinowa",
  "timeOfLaPump":"Godzina ostatnich danych pompy",
  "pumpSN":"Numer seryjny bazy pompy",
  "ReserviorLife":"Pozostały czas przydatności plastra zbiornika",
  "InsulinLeft":"Pozostała insulina",
  "basal":"Bazowa",
  "bolus":"Bolus",
  "totalBasal":"Całkowita dzienna bazowa",
  "lastBolus":"Ostatni bolus",
  "activeInsulin":"Aktywna insulina",
  "totalBolus":"Całkowity dzienny bolus",
  "tampBasal":"Tymcz. bazowa",
  "normalBolus":"Bolus normalny",
  "extendBolus":"Bolus przedłużony",
  "manualStop":"Ręczne zawieszenie",
  "autoStop":"Automatyczne zawieszenie",
  "auto suspend":"Automatyczne zawieszenie",
  "stop":"Zatrzymanie podawania",
  "newPatch":"Nowy plaster",
  "tempBasal":"Tymcz. bazowa",
  "N":"N",
  "E":"P",
  "CN1":"CN",
  "CE":"CP",

  "staticSettings":"Raportuj ustawienia",
  "dataSource":"Dane do wyświetlenia",
  "unit":"Jednostka",
  "glucoseTarget":"Docelowy zakres glukozy",
  "overall":"Ogólnie",
  "Hypoglycemia":"Hipoglikemia",
  "timePeriod":"Okres",
  "postMeal":"Analiza po posiłku",
  "Breakfast":"Śniad.",
  "Lunch":"Lancz",
  "Dinner":"Obiad",
  "night":"Pora nocna",
  "Before":"Przed",
  "After":"Po",
  "Low":"Niski",
  "High":"Wysoki",
  "From":"Od",
  "To":"Do",
  "Hours":"Godziny",
  "Reset":"Przywróć domyślne",
  "RealTime":"W czasie rzeczywistym",
  "uploaded":"Przesłane",
  "sensor":"Czujnik",
  "pdmSN":"Numer seryjny PDM",
  "startTime":"Godzina rozpoczęcia",
  "endTime":"Godzina zakończenia",
  "uploadTime":"Czas przesyłania",
  "pdm":"PDM",
  "Uploaded":"Przesłane",
  "Patch Pump":"Pompa plastra",
  "overLapp":"Sesje nakładają się",
  "showAlert":"Pokaż alerty",

  "dashboard":"Panel roboczy",
  "dboard_glucose_statistics":"Glucose Statistics",
  "dboard_glucose":"Glucose",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insulin",
  "dboard_carbs":"Carbs",
  "dboard_exercise":"Exercise",
  "dboard_glucose_avg":"Average",
  "dboard_cgm_avg":"Średnia",
  "dboard_insulin_avg":"Average Daily Dose",
  "dboard_carbs_avg":"Średnia ilość węglowodanów na dzień",
  "dboard_exercise_avg":"Średni czas na dzień",
  "dboard_sd":"SD",
  "dboard_num":"Nr",
  "dboard_num_days":"# days",
  "dboard_statistics":"Statistics",
  "dboard_BG":"BG",
  "dboard_BG_calibration":"BG / calibration (per day)",
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC high >",
  "dboard_AUC_low":"AUC low <",
  "dboard_highest_value":"Najwyższa wartość",
  "dboard_lowest_value":"Najniższa wartość",

  "dboard_pump":"Pump",
  "dboard_avg_daily_dose":"Średnia Dzienna Dawka",
  "dboard_SD":"Standardowe Odchylenie",
  "dboard_daily_basal":"Dzienna bazalna",
  "dboard_daily_bolus":"Dzienny bolus",
  "dboard_avg_bolus_num":"Średni dzienny bolus/nr. na dzień",
  "dboard_avg_suspend_time":"Średni czas zawieszenia",
  "dboard_avg_reservoir_usage":"Średnie zużycie zbiornika",
  "dboard_days":"days",

  "dboard_manual_bolus":"Ręcznie wprowadzony bolus (stężenie/nr na dzień)",
  "dboard_normal":"-Normalny",
  "dboard_extend":"-Rozszerzony",
  "dboard_combo":"-Połączony",

  "dboard_bolus_calculator":"Kalkulator insuliny (stężenie/nr na dzień)",
  "dboard_food_bolus":"-Kalkulator bolusa z jedzenia",
  "dboard_corr_bolus":"-Kalkulator bolusa",
  "dboard_override_add":"-Przekroczono(+)",
  "dboard_override_sub":"-Przekroczono(-)",

  "dboard_report":"Panel roboczy raport",

  "daily":"Zestawienie dzienne",
  "date":"Data",
  "print":"Drukuj",
  "carbs":"Węglowodany",
  "exercise":"Ruch",
  "heavy":"Ciężkie",
  "Medium":"Średnie",
  "Light":"Lekkie",
  "dailyReport":"Raport zestawienia dziennego",
  "devices":"Urządzenia",
  "tran":"Nadajnik",
  "pumpBase":"Baza pompy",
  "HbA1c":"HbA1c",
  "statics":"Statystyki",
  "glucose":"Glukoza",
  "item":"Pozycja",
  "BG1":"BG",
  "SG1":"SG",
  "avgSD":"Śr. (mmol/L)±SD",
  "avgSD1":"Śr.±SD",
  "min":"Min.",
  "max":"Maks.",
  "ofRead":"Liczba odczytów",
  "ofHypo":"Liczba hipogl./czas trwania",
  "ofAlert":"Liczba alertów",
  "insulin":"Insulina",
  "insulin2":"Insulina",
  "totalDose":"Całkowity dawka dzienna",
  "foodBolus":"Bolus korekcyjny",
  "Food+coor":"Food+corr",
  "calibBolus":"Bolus korekcyjny ",
  "durationStop":"Czas trwania zawieszenia (min)",
  "ofPumpAlert":"Liczba alarmów pompy",
  "ofMeal":"Liczba posiłków",
  "totalExerTime":"Całkowity czas ćwiczenia",
  "exerNum":"Liczba ćwiczeń",
  "avgInten":"Śr. intensywność",
  "target1":"Cel",
  "high1":"Niski",
  "low1":"Wysoki",
  "BG Reading":"BG Reading",

  "dayByday":"Przegląd dzień po dniu",
  "dayBydayRe":"Raport przeglądu dzień po dniu",
  "period":"Okres",

  "sensorOverlay":"Nakładka czujnika",
  "set":"Ustaw",
  "setPeriod":"Ustaw okres",
  "Weekdays":"Dni tygodnia",
  "Weekends":"Weekendy",
  "Mon":"Pon",
  "Tue":"Wt",
  "Wed":"Śr",
  "Thur":"Cz",
  "Thu":"Cz",
  "Fri":"Pt",
  "Sat":"Sob",
  "Sun":"Nd",
  "Average":"Średnia",
  "sensorOlRe":"Raport nakładki czujnika",
  "Avg":"Śr.",
  "±SD":"±SD",
  "ofhypo":"Liczba hipogl.",
  "Everyday":"codziennie",

  "TrendAna":"Analiza trendu",
  "TrendRe":"Raport analizy trendu",
  "sensorGlu":"Poziom glukozy ",
  "ofBGtest":"Liczba testów BG",
  "Basics":"Podstawy",
  "static":"Statystyki",
  "Med":"Med.",
  "med":"Med.",
  "Q1":"P 1",
  "Q3":"P 3",
  "Q11":"P 1",
  "Q31":"P 3",
  "IQR":"IQR",
  "SD":"SD",
  "CV":"CV",
  "SE1":"SE średniej",
  "distri":"Rozkład",
  "stab":"Stabilność",
  "#high":"Liczba wysokich",
  "#low":"Liczba niskich",
  "aucBelow":"Pole pod krzywą poniżej limitu",
  "aucAbove":"Pole pod krzywą nad limitem",
  "bgRead":"Odczyty BG",
  "total":"Całkowita",
  "avg_daily_basal":"Bazowa",
  "avg_daily_bolus":"Bolus",
  "ofBolus":"Liczba bolusów",
  "avgBolus":"Średni bolus",
  "Dura1":"Czas trwania (min)",
  "Avg/Total":"Śr./Całkowita",
  "high":"Wysoki",
  "low":"Niski",
  "#hypo":"Liczba hipogl.",
  "ofExer":"Liczba ćwiczeń",

  "logbook":"Dziennik",
  "dailyTotal":"Całkowita dzienna",
  "High Glucose":"Wysoki poziom glukozy",
  "Low Glucose":"Niski poziom glukozy",
  "No Active Patch":"Brak aktywnych plastrów",
  "Missed Meal":"Pominięty posiłek",
  "Multiple BG Readings":"Wiele odczytów BG",
  "Stop Patch":"Zatrzymaj plaster",
  "Others":"Inne",
  "Other Events":"Inne zdarzenia",
  "logRe":"Raport dziennika",

  "DeviceSetting":"Przegląd ustawień urządzenia",
  "Insulin Pump":"Pompa insulinowa",
  "MaxBasalRate":"Maksymalna szybkość bazowej",
  "BasalPatterns":"Wzorce bazowej",
  "Selected Basal Pattern":"Wybrany wzorzec bazowej",
  "Maximum Bolus":"Maksymalny bolus",
  "Combo/Extended Bolus":"Bolus combo/przedłużony",
  "BG Reminder":"Przypomnienie o BG",
  "Bolus Increment":"Przyrost bolusa",
  "Bolus Calculator":"Kalkulator bolusa",
  "Active Insulin Time":"Czas aktywnej insuliny",
  "IC Ratios":"Stosunki IW",
  "Insulin Sensitivity":"Czułość insuliny",
  "BG Target":"Cel BG",
  "Bolus Reminder":"Przypomnienie o bolusie",
  "CGM":"Ciągły monitor glukozy",
  "CGM System":"System CGM",
  "Glucose Unit":"Jednostka glukozy",
  "Glucose Limits":"Limity glukozy",
  "Predicitive Alerts":"Alerty predykcyjne",
  "Rate Alerts":"Alerty szybkości",
  "type":"Typ",
  "time":"Godzina",
  "data":"Dane",
  "Rate":"Rate",
  "Calibration Reminder":"Przypomnienie o kalibracji",
  "Calibration Repeat":"Powtórzenie kalibracji",
  "Snooze":"Drzemka",
  "Audio Options":"Opcje audio",
  "Confidence Reminder":"Przypomnienie o pewności",
  "Backlight":"Podświetlenie",
  "Sec":"sek.",
  "Alarm Clock":"Budzik",
  "Patch Expiration":"Utrata przydatności plastra",
  "Sensor Expiration":"Utrata przydatności czujnika",
  "Hourly Max":"Maks. godzinowa",
  "Daily Max":"Maks. dzienna",
  "Low Reservoir":"Zbiornik prawie pusty",
  "Low Suspend":"Niski - zawieszenie",
  "Predictive Low Suspend":"Niski predykcyjny - zawieszenie",
  "Rise":"Wzrost",
  "Fall":"Spadek",
  "Auto Off":"Auto Off",
  "Standard":"Standardowa",
  "Exercise":"Ruch",
  "Holiday":"Wakacje",
  "ProgramA":"Wzorzec A",
  "ProgramB":"Wzorzec B",
  "--":"--",
  "Insulin":"Insulina",

  "SUSA":"Auto wył.",
  "SUSHM":"Przekracza podawanie przez maks. 1 godzinę",
  "SUSDM":"Przekracza maks. dzienną dawkę całk.",
  "SUSLSG":"Niski - zawieszenie",
  "SUSPLSG":"Niski predykcyjny - zawieszenie",
  "Pump Restarted":"Pompa uruchomiona ponownie",
  "Meter BG Now":"Zmierz BG",
  "Sensor Exp in 2 Hours":"Przydatność czujnika wygaśnie za 2 godziny",
  "Sensor Exp in 6 Hours":"Przydatność czujnika wygaśnie za 6 godzin",
  "Sensor Exp in 30 Min":"Przydatność czujnika wygaśnie za 30 minut",
  "Sensor Calibration Error":"Błąd kalibracji czujnika",
  "Sensor Error":"Błąd czujnika",

  "Device Settings Report":"Raport ustawień urządzenia",
  "24h Total":"Całkowita 24h",
  "Device Settings at":"Ustawienia urządzenia z ",
  "Start":"Start",
  "Combo/Ext Bolus":"Bolus combo/przedłużony",
  "Time Format":"Format godziny",
  "Device Options（CGM System)":"Opcje urządzenia（system CGM)",
  "Device Options（Insulin Pump)":"Opcje urządzenia（pompa insulinowa)",
  "Dispay Settings (Screen)":"Ustawienia wyświetlania (ekran)",
  "Dispay Settings (Backlight)":"Ustawienia wyświetlania (podświetlenie)",
  "Graph Range":"Zakres wykresu",
  "Range":"Range",
  "Repeat":"Powtórz",
  "Glucose Alerts":"Alerty glukozy",
  "Alert Silence":"Wyciszenie alertu",

  "Create":"Utwórz",
  "Event Filter":"Filtr zdarzeń",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Ketony w moczu",
  "Injection":"Iniekcja",
  "Other":"Inne",
  "Event Type":"Typ zdarzenia",
  "Details":"Szczegóły",
  "Notes":"Uwagi",
  "Source":"Źródło",
  "edit":"Edytuj",
  "Action":"Działanie",
  "EventReport":"Raport zestawienia zdarzeń",
  "By Date":"Wg. daty",
  "By Category":"Wg. kategorii",
  "Event Summary":"Zestawienie zdarzeń",
  "No data":"Brak danych",
  "No1":"No",
  "data1":"data",
  "#":"#",
  "BG Summary":"Zestawienie BG",
  "Carbs Summary":"Zestawienie węglowodanów",
  "Injection Summary":"Zestawienie iniekcji",
  "Exercise Summary":"Zestawienie ćwiczeń",
  "Input Notes":"Wpisz uwagę",

  "Profile":"Profil",
  "Complications":"Komplikacje",
  "Concomitant diseases":"Choroby współistniejące",
  "Suggestion":"Sugestia",
  "Coronary heart disease":"Choroba wieńcowa",
  "High blood lipids":"Wysokie stężenie lipidów we krwi",
  "High blood pressure":"Wysokie stężenie lipidów we krwi",
  "Kidney disease":"Choroba nerek",
  "Neuropathy":"Neuropatia",
  "Obesity":"Otyłość",
  "Peripheral arterial disease":"Choroba naczyń obwodowych",
  "Retinopathy":"Retinopatia",
  "Smoking addiction":"Palenie nałogowe",
  "Enter date":"Wpisz datę",
  "Enter suggestion":"Wpisz sugestię",
  "Enter Notes":"Enter Notes",
  "Select":"Wybierz",
  "Prescription":"Recepta",
  "Medicine":"Lek",
  "Dose":"Dawka",
  "Enter medicine":"Wpisz lek",
  "Enter dose":"Wpisz dawkę",
  "Enterdis":"Enter concomitant diseases",
  "Add note":"Dodaj uwagę",
  "Add Content":"Maksymalna długość to 1000 znaków.",
  "Other suggestions":"Inne sugestie",
  "OK":"OK",
  "HCP":"Pracownik służby zdrowia",
  "Content":"Treść",
  "Records Report":"Raport rekordów",

  "Quick Print":"Szybki wydruk",
  "Quick Print Settings":"Ustawienia szybkiego wydruku",
  "Select duration":"Wybierz czas trwania",
  "One Week":"Tydzień",
  "One Month":"Miesiąc",
  "One Quarter":"Kwartał",
  "End date":"Data końcowa",
  "Yesterday":"Wczoraj",
  "Last Sunday":"Ostatnia niedziela",
  "Last Saturday":"Ostatnia sobota",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Dostosuj",
  "Week Filter":"Filtr tygodni",
  "Select reports to print":"Wybierz raporty do wydrukowania",
  "Daily Summary":"Zestawienie dzienne",
  "Day By Day Overview":"Przegląd dzień po dniu",
  "Sensor Overlay":"Nakładka czujnika",
  "Trend Analysis":"Analiza trendu",
  "Logbook":"Dziennik",
  "Device Settings Review":"Przegląd ustawień urządzenia",
  "createReport":"Utwórz raport",

  "Segment Analysis":"Analiza segmentu",
  "Sensor Glucose Profile":"Profil poziomu glukozy",
  "# of Boluses":"Liczba bolusów",
  "Bolus Insulin":"Insulina w bolusie",
  "Basal Pattern":"Wzorce bazowej ",
  "Segment Analysis Report":"Raport analizy segmentu",
  "Avg Glucose":"Śr. poziom glukozy",
  "Below":"Poniżej ",
  "In Target Range":"W docelowym zakresie",
  "Coefficient of variation":"Współczynnik zmienności",
  "% Time CGM Active":"% czasu aktywności CGM",
  "est_a1c_t1":"Estimated A1C:",
  "est_a1c_t2":"calculated from SG values",
  "est_a1c_t3":"Uwaga: Szacunkowy A1C nie zastąpi badań laboratoryjnych.",

  "acceptTip":" zezwala już ha zdalne wyświetlanie informacji o stanie zdrowia. ",
  "cancelTip":" nie zezwala już ha zdalne wyświetlanie informacji o stanie zdrowia. W razie potrzeby możesz ponownie poprosić.",
  "rejectTip":" nie zgadza się na zdalny dostęp.",
  "Read":"Przeczytaj",

  "Connection":"Połączenie",
  "connections1":"Połączenie",
  "Add Connection":"Dodaj połączenie",
  "SG":"SG",
  "Active Insulin":"Aktywna insulina",
  "Stop following":"Zatrzymaj obserwowanie",
  "Enter username (email)":"Podaj nazwę użytkownika (e-mail)",
  "Search results":"Wyniki wyszukiwania",
  "Send request":"Wyślij prośbę",
  "View graphs":"Wyświetl wykresy",
  "Agree":"Zgoda",
  "Deny":"Odmowa",
  "Remove":"Usuń",
  "Cancel Requset":"Anuluj prośbę",
  "Remark":"Uwaga",

  "Warm up":"Rozgrzewanie",
  "Monitoring":"Monitorowanie",
  "Transmitter Error":"Błąd nadajnika",
  "Sensor Failure":"Awaria czujnika",
  "Sensor Expired":"Czujnik utracił przydatność",
  "Lost Sensor":"Utracony czujnik",
  "Not Calibrated":"Nie skalibrowano",
  "Calibrating":"Kalibrowanie",
  "Calibration Needed":"Wymagana kalibracja",
  "Calibration Error":"Błąd kalibracji",
  "Charging Battery":"Ładowanie baterii",
  "Battery Charged":"Bateria naładowana",

  "To be filled":"Do wypełnienia",
  "Filled with insulin":"Napełniono insuliną",
  "Priming":"Napełnianie",
  "Priming completed":"Zakończono napełnianie",
  "Inserting needle":"Wkładanie igły",
  "Patch activated":"Uaktywniono plaster",
  "Delivering Basal":"Podawanie bazowej",
  "Exceeds Max 1 Hour Delivery":"Przekracza podawanie przez maks. 1 godzinę",
  "Exceeds Max TDD":"Przekracza maks. dzienną dawkę całk.",
  "Suspend":"Zawieszenie",
  "Occlusion Detected":"Wykryto zatkanie",
  "Patch Expired":"Plaster utracił przydatność",
  "Empty Reservoir":"Pusty zbiornik",
  "Patch Error":"Błąd plastra",
  "Pump Base Error":"Błąd bazy pompy",
  "Patch Battery Depleted":"Rozładowana bateria plastra",
  "Magnetic sensor not calibrated":"Czujnik magnetyczny nieskalibrowany",

  "Patient Profile":"Profil pacjenta",

  "On":"Wł.",
  "on":"Wł.",
  "Off":"Wył.",
  "off":"Wył.",

  "CORONARY_HEART_DISEASE":"Choroba wieńcowa",
  "HIGH_BLOOD_LIPIDS":"Wysokie stężenie lipidów we krwi",
  "HIGH_BLOOD_PRESSURE":"Wysokie stężenie lipidów we krwi",
  "KIDNEY_DISEASE":"Choroba nerek",
  "NEUROPATHY":"Neuropatia",
  "OBESITY":"Otyłość",
  "PERIPHERAL_ARTERIAL_DISEASE":"Choroba naczyń obwodowych",
  "RETINOPATHY":"Retinopatia",
  "SMOKING_ADDICTION":"Palenie nałogowe",

  "saveTip":"Zapisano.",
  "changePaTip":"Hasło zostało zmienione.",
  "enterEmTip":"Podaj adres e-mail.",
  "verErrTip":"Błędny kod weryfikacyjny.",
  "chooseEventTip":"Wybierz zdarzenia do drukowania",
  "chooseDataTip":"Wybierz dane do wydrukowania",
  "dateWrongTip":"The end date cannot be earlier than the start date.",
  "infoWrongTip":"Wypełnij wszystkie wymagane pola.",
  "createdSuccssTip":"Utworzono",
  "selectData":"Wybierz dane do zapisania",

  "acceSu":"Zaakceptuj prośbę o połączenie",
  "acceEr":"Nie można dodać nowego połączenia",
  "rejeSu":"Prośba o połączenie odrzucona",
  "rejeEr":"Nie można odrzucić prośby",

  "userNotExist":"Nazwa użytkownika nie istnieje.",
  "Password incorrect":"Błędne hasło.",
  "UserType incorrect":"Błędny typ użytkownika",

  "registSuccess":"Twoje konto zostało utworzone.",
  "registFailed":"Nie można zarejestrować nowego konta.",
  "sentSuccess":"Wysłano komunikat",
  "sentFailed":"Nie można wysłać komunikatu",
  "Input error":"Błąd wejścia",

  "deletePtip":"Na pewno chcesz usunąć tych pacjentów?",
  "deleteEvents":"Na pewno chcesz usunąć te zdarzenia?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Na pewno chcesz usunąć?",
  "confirm":"Potwierdź",
  "deleteSuccess":"Usunięto",
  "deleteFailed":"Nie można usunąć tej pozycji",
  "modifySuccess":"Zmieniono",
  "modifyFailed":"Nie można zmienić",
  "createSuccess":"Utworzono",
  "createFailed":"Nie udało się utworzyć",
  "editSuccess":"Przeprowadzono edycję",
  "editFailed":"Nie udało się przeprowadzić edycji",
  "Time overlapped":"Wybrane sesja nakładają się.",

  "stopFollow":"Na pewno chcesz zatrzymać obserwowanie tego pacjenta?",
  "CancelTip1":"Na pewno chcesz usunąć to połączenie?",

  "Warning":"Ostrzeżenie",
  "agreeConnect":"Jeśli klikniesz „Zgoda”, aby zaakceptować prośbę o połączenie, dane o stanie Twojego zdrowia będą dostępne w nowym połączeniu.",
  "denyConnect":"Na pewno chcesz usunąć odrzucić prośbę o połączenie?",
  "deleteConnect":"Na pewno chcesz usunąć to połączenie? Jeśli odrzucisz, połączenie nie będzie dostępne w celu wyświetlania danych o stanie Twoje zdrowia.",

  "Choose the events to print":"Wybierz zdarzenia do drukowania",
  "tryAgain":"Spróbuj ponownie",
  "username and password is required":"username and password is required",
  "A name is required":"Wymagane jest imię i nazwisko.",
  "username is required":"Wymagana jest nazwa użytkownika.",
  "The date choose wrong":"Wybrano błędną datę",
  "Date no more than 14 days":"Nie można wybrać więcej niż 14 dni.",

  "CancelTip":"Na pewno chcesz usunąć połączenie?",
  "removeConnect":"Usunięto",

  "dateErr1":"Nie można wybrać więcej niż 90 dni.",
  "dateErr2":"Data końcowa nie może być wcześniejsza niż początkowa.",

  "Not Filled":"Unspecified",
  "Today":"Dzisiaj",
  "duration":"Czas trwania",
  "interval":"Interval",
  "7 days":"7 dni",
  "14 days":"14 dni",
  "30 days":"30 dni",
  "90 days":"90 dni",
  "g":"g",

  "Sound+Vibrate":"Audio+Wibracje",
  "Sound":"Audio",
  "Vibrate":"Wibracje",
  "Silent":"Nie przeszkadzać",
  "1":"Raz",
  "2":"Codziennie",
  "noMes":"Brak komunikatów.",
  "noConnect":"Brak połączeń.",
  "Customize":"Dostosuj",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Jan",
  "Feb":"Feb",
  "Mar":"Mar",
  "Apr":"Apr",
  "May":"May",
  "Jun":"Jun",
  "Jul":"Jul",
  "Aug":"Aug",
  "Sep":"Sep",
  "Oct":"Oct",
  "Nov":"Nov",
  "Dec":"Dec",
  "ApplyTip":" request to view your data.",
  "noReadings":"Brak odczytów",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Pobrane dane",
  "daop_uploaded_data_text":"Dane są z aplikacji EasyTouch lub EasyView z iPada.",
  "daop_realtime_data":"Dane w czasie rzeczywistym",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(J)",
  "ins_unit2":"J",
  "basal_unit":"(J/G)",
  "basal_unit2":"J/G",

  // 告警
  "Alerts_Patch_Battery_Low":"Słaba bateria plastra",
  "Alerts_Patch_Battery_Depleted":"Rozładowana bateria plastra", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Zbiornik prawie pusty", // update
  "Alerts_Empty_Reservoir":"Pusty zbiornik",
  "Alerts_Patch_Expiration_Advisory":"Rada dot. utraty przydatności plastra",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Plaster utracił przydatność", // update
  "Alerts_Patch_Error":"Błąd plastra",
  "Alerts_Pump_Base_Error":"Błąd bazy pompy",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Wykryto zatkanie", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Przekracza maks. dzienną dawkę całk.", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Przekracza podawanie przez maks. 1 godz.",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Niski predykcyjny - zawieszenie", // update
  "Alerts_Low_Suspend":"Niski - zawieszenie",
  "Alerts_Auto_Off":"Auto wył.", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Utracony czujnik", // update
  "Alerts_Transmitter_Battery_Low":"Słaba bateria nadajnika",
  "Alerts_Charge_Transmitter":"Naładuj nadajnik",
  "Alerts_Sensor_Error":"Błąd czujnika", // update
  "Alerts_Transmitter_Error":"Błąd nadajnika",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Awaria czujnika",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Zmierz BG",
  "Alerts_Sensor_Exp_in_6_Hours":"Przydatność czujnika wygaśnie za 6 godzin",
  "Alerts_Sensor_Exp_in_2_Hours":"Przydatność czujnika wygaśnie za 2 godziny", // update
  "Alerts_Sensor_Exp_in_30_Min":"Przydatność czujnika wygaśnie za 30 minut",
  "Alerts_Sensor_Expired":"Czujnik utracił przydatność", // update
  "Alerts_Rapid_Rise":"Szybki wzrost",
  "Alerts_Rapid_Fall":"Szybki spadek",
  "Alerts_High_Predicted":"Wysoki przewidywany",
  "Alerts_Low_Predicted":"Niski przewidywany",
  "Alerts_High_Glucose":"Wysoki poziom glukozy", // update
  "Alerts_Low_Glucose":"Niski poziom glukozy", // update
  "Alerts_Below_3.1_mmol/L":"Poniżej 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2":"Słaba bateria nadajnika",

  "Alerts_PDM_Battery_Low":"Słaba bateria PDM",
  "Alerts_Replace_Battery":"Naładuj PDM",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Alerty",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pompa",
  //"CGM":"CGM",
  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Time in Auto Mode",
  "t1221_Average_SG_SD":"Average SG ± SD",
  "t1221_Time_in_Target_Range":"Time in Target Range",
  "t1221_Time_above_Range":"Time above Range",
  "t1221_Time_below_Range":"Time below Range",
  "t1221_Auto_Basal_per_day":"Auto Basal (per day)",
  "t1221_Auto_Bolus_per_day":"Auto Bolus (per day)",
  "t1221_Auto_Mode_Exits":"Auto Mode Exits",
  "t1221_No_Sensor_readings":"No Sensor readings",
  "t1221_Max_Delivery":"Max Delivery",
  "t1221_Min_Delivery":"Min Delivery",
  "t1222_autoModeBasal":"Auto Mode Basal",
  "t1222_autoModeCorrBolus":"Auto Mode Correct Bolus",
  "t1222_autoSnack":"Auto Snack",
  "t1222_autoBreakfast":"Auto Breakfast",
  "t1222_autoLunch":"Auto Lunch",
  "t1222_autoDinner":"Auto Dinner",
  "t1222_autoExercise":"Auto Exercise",
  "t1222_Snack":"Snack",
  "t1222_Auto_Mode":"Auto Mode",
  "t1222_Time_in_Auto_Mode":"Time in Auto Mode(%)",
  "t1222_Avg_SD":"Avg.(mmol/L)±SD",
  "t1222_Target_Range":"Target Range(%)",
  "t1222_Above_Range":"Above Range(%)",
  "t1222_Below_Range":"Below Range(%)",
  "t1222_Auto_Mode_Exits":"# of Auto Mode Exits",
  "t1221_Auto_Mode":"Auto Mode",
  "t1222_auto_basal":"Auto Basal",
  "t1222_auto_bolus":"Auto Bolus",
  "t0805_User_Management":"Zarządzanie użytkownikami",
  "t0805_Patient_Management":"Zarządzanie pacjentem",
  "t0805_Operation_History":"Historia operacji",
  "t0805_User_List":"Lista użytkowników",
  "t0805_User":"Użytkownik",
  "t0805_Time":"Czas",
  "t0805_Operation_Type":"Typ operacji",
  "t0805_Back":"Wstecz",
  "t0805_Add":"Dodaj",
  "t0805_Delete":"Usuń",
  "t0809_Add_User":"Dodaj użytkownika",
  "t1028_Pattern_C":"Wzorzec C",
  "t1028_Pattern_D":"Wzorzec D",
  "t1029_Auto_meal_bolus":"Auto meal bolus",
  "t1029_Auto_mode_correction_bolus":"Auto mode correction bolus",
  "t1029_Sick":"Chory",
  "t1029_Auto_Mode_Feature":"Auto Mode Feature",
  "t1029_Target_SG":"Target SG",
  "t1029_Auto_Meal_Handling":"Auto Meal Handling",
  "t1029_Total_Daily_Dose":"Total Daily Dose",
  "t1029_Pump_Light":"Pump Light",
  "t1029_Alerts_for_Hypo":"Alerts for Hypo",
  "t1102_Out_of_Range":"Pompa poza zakresem",
  "t1102_Command_Reminder":"Przypomnienie polecenia",
  "t1102_Alarms_Alerts_on_APP":"Alarmy i alerty na pompie",
  "t1102_Alarms_on_App":"Alarmy w aplikacji",
  "t1102_Alerts_on_App":"Alerty w aplikacji",
  "t1102_Factory_Calibration":"Kalibracja Fabryczna",
  "t1102_Alerts_for_Low":"Alerty dla niskich",
  "t1102_Alerts_for_High":"Alarrty dla wysokich",
  "t1102_Alerts_for_Others":"Alerty dla innych",
  "t1102_Adjustment":"Adjustment",
  "t1102_Suggested":"Sugerowane",
  "t1103_Glucose":"Glukoza",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insulina",
  "t1103_Carbs":"Węglowodany",
  "t1103_Exercise":"Ruch",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Target Range",
  "t1103_Overall_Tine_In_Range":"Overall: Time In Range",
  "t1103_Basal":"Basal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Auto Mode: Time In Range",
  "t1103_Time_below_range":"Time below range",
  "t1103_Time_above_range":"Time above range",
  "t1103_Time_in_target_range":"Time in target range",
  "t1103_Incorrect_Password":"Nieprawidłowe hasło, $1 Pozostała próba, wprowadź poprawne hasło.",
  "t1103_Incorrect_locked":"Nieudane próby przekraczają limit, konto zostało zablokowane. Spróbuj ponownie za $1 minut.",
  "t1104_The_data_is_from":"Dane są z aplikacji EasySense lub EasyPatch.",
  "t1104_Privacy_Policy":"Privacy Policy and Terms of Use",
  "t1104_updated_privacy_policy":"We have updated our privacy policy and terms of use. Please read and agree to all terms to continue using EasyView.",
  "t1104_Disagree":"Disagree",
  "t1104_Agree":"Zgoda",
  "t1105_Upload_History":"Historia przesyłania",
  "t1105_Delete_Data":"Usunąć dane",
  "t1105_Target_Range":"Target Range",
  "t1105_request_to_view_your_data":"$1 żądanie wyświetlenia Twoich danych.",
  "t1105_Recent_Updates":"Ostatnie aktualizacje",
  "t1108_No_data":"Brak danych",
  "t1108_Pump_Bash_SN":"Numer seryjny bazy pompy",
  "t1108_Transmitter_SN":"Numer seryjny nadajnika",
  "t1112_Normal_Glucose":"Normalna Glukoza",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Bolus ręczny lub bolus zmodyfikowany",
  "t1112_Auto_Mode_Started":"Auto Mode Started",
  "t1112_Auto_Mode_Exit":"Auto Mode Exit",
  "t1112_Normal_Bolus":"Bolus normalny",
  "t1112_Extended_Bolus":"Bolus przedł.",
  "t1112_Combo_Bolus":"Bolus combo",
  "t1112_Carbs":"Węglowod.",
  "t1112_Glucose":"Glukoza",
  "t1112_BG":"BG",
  "t1112_Audio":"Audio",
  "t1112_Tone":"Stonować",
  "t1112_Audio_Options":"Opcje audio",
  "t1112_Weight_Unit":"Jednostka Wagi",
  "t1112_Height_Unit":"Jednostka Wzrostu",
  "t1112_Not_available":"Niedostępne",
  "t1112_Number":"Numer",
  "t1112_days":"# dni",
  "t1112_min":"min",
  "t1113_days":"dni",
  "t1215_Security":"Bezpieczeństwo",
  "t1215_MFA":"Uwierzytelnianie wieloskładnikowe (MFA)",
  "t1215_Enter_verification_code":"Wpisz kod weryfikacyjny",
  "t1215_Multi_factor_ON":"Uwierzytelnianie wieloskładnikowe jest WŁĄCZONE. Kod weryfikacyjny został wysłany na adres $1 Prześlij kod weryfikacyjny",
  "t1215_Verification_code_incorrect":"Błędny kod weryfikacyjny",
  "t1215_Show_Glucose_Value":"Pokaż wartość glukozy",
  "t1221_enter_verification_code":"Wprowadź 6-cyfrowy kod weryfikacyjny wysłany do $1.",
  "t1221_Verification_Success":"Zweryfikowano pomyślnie",
  "t1222_We_will_only_process":"Dane dotyczące opieki zdrowotnej będziemy przetwarzać wyłącznie za pośrednictwem aplikacji Medtrum/strony internetowej za Twoją zgodą. ",
  "t1222_If_you_are_under_years":"Jeśli masz mniej niż 16 lat, będziesz potrzebować zgody rodzica lub opiekuna prawnego, aby zarejestrować się w tej aplikacji.",
  "t1221_register_cn":"Masz prawo nie przesyłać żadnych danych urządzenia do aplikacji, w którym to przypadku dane nie będą dostępne dla innych. Jeśli zdecydujesz się nie rejestrować w aplikacji/witrynie Medtrum, jedyny zapis danych dotyczących opieki zdrowotnej znajduje się na samym urządzeniu. ",
  "t1221_register_eu":"Jeśli zdecydujesz się zarejestrować swoje konto Medtrum i uzyskać dostęp do naszej aplikacji za pomocą konta, dane medyczne zapisane w aplikacji zostaną przesłane na nasz serwer w Europie i będą przechowywane przez 2 lata. Masz prawo nie przesyłać żadnych danych urządzenia do aplikacji, w którym to przypadku dane nie będą dostępne dla innych. Jeśli zdecydujesz się nie rejestrować w aplikacji/witrynie Medtrum, jedyny zapis danych dotyczących opieki zdrowotnej znajduje się na samym urządzeniu.",
  "t1221_register_follow":"Dane dotyczące opieki zdrowotnej będziemy przetwarzać wyłącznie za pośrednictwem aplikacji Medtrum/strony internetowej za Twoją zgodą. ",
  "t1222_Terms_of_Use":"Warunki użytkowania firmy Medtrum",
  "t1222_Privacy_Policy":"zasady zachowania poufności informacji firmy Medtrum",
  "t1222_Create_Account":"Utwórz konto",
  "t1222_Back":"Wstecz",
  "t1222_Verify_your_account":"Zweryfikuj swoje konto",
  "t1222_please_check_your_account":"Wyślemy kod weryfikacyjny do $1, sprawdź swoje konto.",
  "t1222_I_Agree_to":"Akceptuję $1",
  "t1223_Invalid_Verification_Code":"Nieprawidłowy kod weryfikacyjny. Proszę spróbuj ponownie.",
}

//export default {plMessages}



// WEBPACK FOOTER //
// ./src/lang/pl.js